import React, { useContext } from "react";
import {
    Grid,
} from "@mui/material";
import { DateTimeFmt } from "../../../../utils/DataUtils";
import language from '../../../../nls/language.json';
import Context from "../../../../context/Context";
import "./styles.css"
import { statusColor } from "../../../../utils/statusColor";

export default function InfoPendency({
    data,
}) {
    const {
        selectedCountry,
    } = useContext(Context);

    return (
        <Grid container className="info-pendency-container">
            <p>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.pendencia.info.title}:
                <span className={`badge bg-${statusColor(data) === 'error' ? 'danger' : statusColor(data)} text-dark`}>
                    {data.pend_Status}
                </span>
            </p>
            <p>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.pendencia.info.setorResponsabel}: {data.isagA_Pendencias_Motivos?.pendMot_Responsavel}</p>
            <p>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.pendencia.info.dataEntrada}: {DateTimeFmt(data.pend_DataEntrada)}</p>
            {data.pend_DataPrevisao && (<p>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.pendencia.info.previsaoConclusao}: {DateTimeFmt(data.pend_DataPrevisao)}</p>)}
            <p>{language[selectedCountry.name].Dashboard.pecasSetor.ficha.pendencia.info.motivo}: {data.isagA_Pendencias_Motivos.pendMot_Descricao}</p>
        </Grid>
    );
}
